import {
  INVENTORY_REPAIR_STATE_REQUESTED,
  INVENTORY_STATE_ASSIGNED,
  INVENTORY_STATE_CANCELED,
  INVENTORY_STATE_DELIVERED,
  INVENTORY_STATE_FOR_SALE_ONLINE,
  INVENTORY_STATE_INVOICED,
  INVENTORY_STATE_PRICE_CHANGE_REQUEST,
  INVENTORY_STATE_PURCHASE_REQUEST,
  INVENTORY_STATE_RETURNED,
  INVENTORY_STATE_RETURNED_CAR_LOADED,
  INVENTORY_STATE_RETURNED_TRANSPORTATION_CONFIRMED,
  INVENTORY_STATE_RETURNED_TRANSPORTATION_REQUEST,
  INVENTORY_STATE_UNDER_NEGOTIATION,
} from 'lib/inventoryStates'
import { addDays, endOfDay, format, startOfDay } from 'date-fns'
import { Box, Link, Stack, Typography } from '@mui/material'
import { getFormattedNumber } from 'lib/carDetailsLib'
import axios from 'axios'
import config from 'config'
import { camelCase } from 'lodash'

import {
  INVENTORY_ACTION_CANCELED,
  INVENTORY_ACTION_DELIVERED,
  INVENTORY_ACTION_FOR_SALE_ONLINE,
  INVENTORY_ACTION_INVOICED,
  INVENTORY_ACTION_PRICE_CHANGE_REQUEST,
  INVENTORY_ACTION_PURCHASE_REQUEST,
  INVENTORY_ACTION_PURCHASE_REQUEST_B2B,
  INVENTORY_ACTION_REPAIR_CONFIRMATION,
  INVENTORY_ACTION_REPAIR_REQUEST,
  INVENTORY_ACTION_RETURN,
  INVENTORY_ACTION_RETURN_CAR_ARRIVED,
  INVENTORY_ACTION_RETURN_CAR_LOADED,
  INVENTORY_ACTION_RETURN_TRANSPORTATION_CONFIRMED,
  INVENTORY_ACTION_RETURN_TRANSPORTATION_REQUEST,
  INVENTORY_ACTION_REVERT_CHANGE_STATE,
  INVENTORY_ACTION_UNDER_NEGOTIATION,
  INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST,
} from './const'

export const INVENTORY_ACTIONS_MAP_STATE_DE = {
  [INVENTORY_ACTION_CANCELED]: {
    checkPartnerAdmin: true,
    checkSixtAdmin: false,
    checkSuperAdmin: false,
    checkB2C: false,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [INVENTORY_STATE_INVOICED],
    inventoryRemoveTransitionsB2B: [INVENTORY_STATE_INVOICED],
  },
  [INVENTORY_ACTION_DELIVERED]: {
    checkPartnerAdmin: true,
    checkSixtAdmin: false,
    checkSuperAdmin: false,
    checkB2C: false,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [INVENTORY_STATE_ASSIGNED],
    form: (t) => ({
      date1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_DELIVERED}.date1.label`
        ),
        getProps: (car) => {
          return {
            min: car?.assignedAt ? startOfDay(new Date(car?.assignedAt)) : null,
            max: endOfDay(new Date()),
          }
        },
      },
      document1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_DELIVERED}.document1.label`
        ),
        loadLabel: t(
          `partnerInventory.action.${INVENTORY_ACTION_DELIVERED}.document1.loadLabel`
        ),
      },
    }),
  },
  [INVENTORY_ACTION_FOR_SALE_ONLINE]: {
    checkPartnerAdmin: true,
    checkSixtAdmin: false,
    checkSuperAdmin: false,
    checkB2C: false,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [
      INVENTORY_STATE_DELIVERED,
      INVENTORY_STATE_UNDER_NEGOTIATION,
      INVENTORY_STATE_CANCELED,
      // INVENTORY_STATE_PRICE_CHANGE_REQUEST,
    ],
  },
  [INVENTORY_ACTION_INVOICED]: {
    checkPartnerAdmin: false,
    checkSixtAdmin: true,
    checkSuperAdmin: true,
    checkB2C: true,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [INVENTORY_STATE_PURCHASE_REQUEST],
    form: (t) => ({
      document1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_INVOICED}.document1.label`
        ),
        loadLabel: t(
          `partnerInventory.action.${INVENTORY_ACTION_INVOICED}.document1.loadLabel`
        ),
      },
    }),
  },
  [INVENTORY_ACTION_PRICE_CHANGE_REQUEST]: {
    checkPartnerAdmin: true,
    checkSixtAdmin: false,
    checkSuperAdmin: false,
    checkB2C: false,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [INVENTORY_STATE_UNDER_NEGOTIATION],
    form: (t) => ({
      getHeader: (car) => {
        return car ? (
          <Stack py={1}>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_PRICE_CHANGE_REQUEST}.car`,
                { attribute: car.vin }
              )}
            </Typography>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_PRICE_CHANGE_REQUEST}.suggestedPrice`,
                { attribute: `€ ${getFormattedNumber(car.price + car.fee)}` }
              )}
            </Typography>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_PRICE_CHANGE_REQUEST}.fee`,
                { attribute: `€ ${getFormattedNumber(car.fee)}` }
              )}
            </Typography>
          </Stack>
        ) : (
          false
        )
      },
      validate: (car, values) => {
        if (car.price > Number(values.number1 || 0)) {
          return t(
            `partnerInventory.action.${INVENTORY_ACTION_PRICE_CHANGE_REQUEST}.errors.validate`,
            { attribute: `€ ${getFormattedNumber(car.price)}` }
          )
        }
      },

      date1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_PRICE_CHANGE_REQUEST}.date1.label`
        ),
        getProps: () => {
          return {
            value: addDays(startOfDay(new Date()), 7),
            min: endOfDay(new Date()),
            max: addDays(startOfDay(new Date()), 30),
          }
        },
      },
      number1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_PRICE_CHANGE_REQUEST}.number1.label`
        ),
      },
      string1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_PRICE_CHANGE_REQUEST}.string1.label`
        ),
      },
    }),
  },
  [INVENTORY_ACTION_PURCHASE_REQUEST]: {
    checkPartnerAdmin: true,
    checkSixtAdmin: false,
    checkSuperAdmin: false,
    checkB2C: false,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [
      INVENTORY_STATE_UNDER_NEGOTIATION,
      INVENTORY_STATE_PRICE_CHANGE_REQUEST,
    ],
  },
  [INVENTORY_ACTION_REPAIR_REQUEST]: {
    checkPartnerAdmin: true,
    checkSixtAdmin: false,
    checkSuperAdmin: false,
    checkB2C: true,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryNotAllowedTransitions: [
      INVENTORY_STATE_ASSIGNED,
      INVENTORY_ACTION_INVOICED,
    ],
    inventoryNotAllowedRepairTransitions: [INVENTORY_REPAIR_STATE_REQUESTED],
    form: (t) => ({
      getHeader: (car) => {
        return car ? (
          <Typography>
            {t(
              `partnerInventory.action.${INVENTORY_ACTION_REPAIR_REQUEST}.description`,
              {
                attribute: car.vin,
              }
            )}
          </Typography>
        ) : (
          false
        )
      },
      validate: (car, values) => {
        if (!values.document1 && !values.document2 && !values.document3)
          return t(
            `partnerInventory.action.${INVENTORY_ACTION_REPAIR_REQUEST}.errors.atLeastOneFile`
          )
      },
      document1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_REPAIR_REQUEST}.document1.label`
        ),
        loadLabel: t(
          `partnerInventory.action.${INVENTORY_ACTION_REPAIR_REQUEST}.document1.loadLabel`
        ),
        // optional: true,
        getProps: () => {
          return {
            // eslint-disable-next-line sonarjs/no-duplicate-string
            accept: '.pdf, .jpg, .jpeg',
          }
        },
      },
      document2: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_REPAIR_REQUEST}.document2.label`
        ),
        loadLabel: t(
          `partnerInventory.action.${INVENTORY_ACTION_REPAIR_REQUEST}.document2.loadLabel`
        ),
        optional: true,
        // eslint-disable-next-line sonarjs/no-identical-functions
        getProps: () => {
          return {
            accept: '.pdf, .jpg, .jpeg',
          }
        },
      },
      document3: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_REPAIR_REQUEST}.document3.label`
        ),
        loadLabel: t(
          `partnerInventory.action.${INVENTORY_ACTION_REPAIR_REQUEST}.document3.loadLabel`
        ),
        optional: true,
        // eslint-disable-next-line sonarjs/no-identical-functions
        getProps: () => {
          return {
            accept: '.pdf, .jpg, .jpeg',
          }
        },
      },
    }),
  },
  [INVENTORY_ACTION_REPAIR_CONFIRMATION]: {
    checkPartnerAdmin: false,
    checkSixtAdmin: true,
    checkSuperAdmin: true,
    checkB2C: false,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedRepairTransitions: [INVENTORY_REPAIR_STATE_REQUESTED],
    form: (t) => ({
      getHeader: (car) => {
        return car ? (
          <>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_REPAIR_CONFIRMATION}.description`,
                {
                  attribute: car.vin,
                }
              )}
            </Typography>
            {Array.from({ length: 3 }, (_, i) => i + 1).map(
              (i) =>
                car[`repairDocument${i}`] && (
                  <Link
                    key={`${car.inventoryId}_document_${i}`}
                    component={Box}
                    variant="body2"
                    onClick={async () => {
                      const result = await axios.get(
                        `${
                          config.apiBaseUrl
                        }inventory/sign-download-document?filename=${(
                          car.vin ?? ''
                        ).toUpperCase()}/${car.sessionId}/${
                          // eslint-disable-next-line sonarjs/no-nested-template-literals
                          car[`repairDocument${i}`]
                        }`
                      )
                      window.location = result.data?.body?.signedUrl
                    }}
                    color="primary"
                    sx={{ /* textDecoration: 'none', */ cursor: 'pointer' }}
                  >
                    {car[`repairDocument${i}`]}
                  </Link>
                )
            )}
          </>
        ) : (
          false
        )
      },
      validate: (car, values) => {
        if (!values.boolean1 && (values.string1 ?? '').trim() === '')
          return t(
            `partnerInventory.action.${INVENTORY_ACTION_REPAIR_CONFIRMATION}.errors.mandatoryCommentOnRejection`
          )
      },
      boolean1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_REPAIR_CONFIRMATION}.approve`
        ),
        labelLeft: t(
          `partnerInventory.action.${INVENTORY_ACTION_REPAIR_CONFIRMATION}.reject`
        ),
      },
      string1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_REPAIR_CONFIRMATION}.comment`
        ),
      },
    }),
  },

  [INVENTORY_ACTION_RETURN]: {
    checkPartnerAdmin: false,
    checkSixtAdmin: true,
    checkSuperAdmin: true,
    checkB2C: true,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [
      INVENTORY_STATE_ASSIGNED,
      INVENTORY_STATE_DELIVERED,
      INVENTORY_STATE_FOR_SALE_ONLINE,
      INVENTORY_STATE_UNDER_NEGOTIATION,
      INVENTORY_STATE_PRICE_CHANGE_REQUEST,
      INVENTORY_STATE_PURCHASE_REQUEST,
    ],
  },
  [INVENTORY_ACTION_RETURN_CAR_ARRIVED]: {
    checkPartnerAdmin: false,
    checkSixtAdmin: true,
    checkSuperAdmin: true,
    checkB2C: true,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [INVENTORY_STATE_RETURNED_CAR_LOADED],
  },
  [INVENTORY_ACTION_RETURN_CAR_LOADED]: {
    checkPartnerAdmin: true,
    checkSixtAdmin: false,
    checkSuperAdmin: false,
    checkB2C: false,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [
      INVENTORY_STATE_RETURNED_TRANSPORTATION_CONFIRMED,
    ],
    form: (t) => ({
      document1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_RETURN_CAR_LOADED}.document1.label`
        ),
        loadLabel: t(
          `partnerInventory.action.${INVENTORY_ACTION_RETURN_CAR_LOADED}.document1.loadLabel`
        ),
      },
    }),
  },
  [INVENTORY_ACTION_RETURN_TRANSPORTATION_CONFIRMED]: {
    checkPartnerAdmin: false,
    checkSixtAdmin: true,
    checkSuperAdmin: true,
    checkB2C: true,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [
      INVENTORY_STATE_RETURNED_TRANSPORTATION_REQUEST,
    ],
  },
  [INVENTORY_ACTION_RETURN_TRANSPORTATION_REQUEST]: {
    checkPartnerAdmin: true,
    checkSixtAdmin: false,
    checkSuperAdmin: false,
    checkB2C: false,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [INVENTORY_STATE_RETURNED],
  },
  [INVENTORY_ACTION_UNDER_NEGOTIATION]: {
    checkPartnerAdmin: true,
    checkSixtAdmin: false,
    checkSuperAdmin: false,
    checkB2C: false,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [INVENTORY_STATE_FOR_SALE_ONLINE],
  },
  [INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST]: {
    checkPartnerAdmin: false,
    checkSixtAdmin: true,
    checkSuperAdmin: true,
    checkB2C: false,
    checkChannelB2C: false,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [INVENTORY_STATE_PRICE_CHANGE_REQUEST],
    form: (t) => ({
      getHeader: (car) => {
        return car ? (
          <Stack py={1}>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST}.car`,
                { attribute: car.vin }
              )}
            </Typography>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST}.suggestedPrice`,
                { attribute: `€ ${getFormattedNumber(car.price + car.fee)}` }
              )}
            </Typography>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST}.fee`,
                { attribute: `€ ${getFormattedNumber(car.fee)}` }
              )}
            </Typography>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST}.newProposal`,
                {
                  attribute: `€ ${getFormattedNumber(
                    car.negotiationPartnerPrice
                  )}`,
                }
              )}
            </Typography>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST}.proposalExpiresAt`,
                {
                  attribute: format(
                    new Date(car.negotiationPartnerExpire),
                    'yyyy-MM-dd'
                  ),
                }
              )}
            </Typography>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST}.comment`,
                { attribute: car.negotiationPartnerComment }
              )}
            </Typography>
          </Stack>
        ) : (
          false
        )
      },
      date1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST}.date1.label`
        ),
        getProps: () => {
          return {
            value: addDays(startOfDay(new Date()), 7),
            min: endOfDay(new Date()),
            max: addDays(startOfDay(new Date()), 31),
          }
        },
      },
      number1: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST}.number1.label`
        ),
      },
      number2: {
        label: t(
          `partnerInventory.action.${INVENTORY_ACTION_UNDER_NEGOTIATION_FROM_PRICE_CHANGE_REQUEST}.number2.label`
        ),
      },
    }),
  },
  [INVENTORY_ACTION_PURCHASE_REQUEST_B2B]: {
    checkPartnerAdmin: true,
    checkSixtAdmin: false,
    checkSuperAdmin: false,
    checkB2C: false,
    checkChannelB2C: true,
    checkHistoryCount: false,
    inventoryAllowedTransitions: [INVENTORY_STATE_RETURNED],
  },
  [INVENTORY_ACTION_REVERT_CHANGE_STATE]: {
    checkPartnerAdmin: false,
    checkSixtAdmin: true,
    checkSuperAdmin: true,
    checkB2C: false,
    checkChannelB2C: false,
    checkHistoryCount: true,
    inventoryAllowedTransitions: [],
    form: (t) => ({
      getHeader: (car, t) => {
        return car ? (
          <Stack py={1}>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_REVERT_CHANGE_STATE}.car`,
                { attribute: car.vin }
              )}
            </Typography>
            <Typography>
              {t(
                `partnerInventory.action.${INVENTORY_ACTION_REVERT_CHANGE_STATE}.previousState`,
                {
                  attribute: t(
                    `partnerInventory.menu.${camelCase(car.previousState)}`
                  ),
                }
              )}
            </Typography>
          </Stack>
        ) : (
          false
        )
      },
    }),
  },
}
